import { Account } from '@adjust/dashboard-core/api/types';
import { User, App, Tracker, Link } from '../types';
import { http } from './http';

export const getCurrentUser = () => http.accounts.get<User>('/current_user').then(response => response.data);

export const getCurrentAccount = () => http.accounts.get<Account>('/current_account').then(response => response.data);

export const logout = () => http.accounts.delete<void>('/users/sign_out');

export const switchAccount = (accountId: number) =>
  http.accounts.post<void>('/accounts/switch', {
    account_id: accountId,
    skip_redirect: true,
  });

export const searchAccount = (search: string) =>
  http.accounts
    .get<Account[]>('/accounts/switch.json', {
      params: {
        search,
      },
    })
    .then(response => response.data);

export const getApps = () => http.dashboard.get<{ apps: App[] }>('/apps').then(response => response.data.apps);

export const getApp = (token: string) => http.dashboard.get<App>(`/apps/${token}`).then(response => response.data);

export const getAppTrackers = (token: string) => {
  return http.dashboard
    .get<{ trackers: Tracker[] }>(`/apps/${token}/trackers`, {
      params: {
        include_archived: false,
        with_special_trackers: true,
      },
    })
    .then(response => response.data.trackers);
};

export const getTracker = (token: string) =>
  http.dashboard.get<Tracker>(`/trackers/${token}`).then(response => response.data);

export const getLinks = () =>
  http.dashboard.get<{ links: Link[] }>('/deeplink_generator/links').then(response => response.data.links);

export const createLink = (link: Omit<Link, 'id'>) =>
  http.dashboard
    .post<Link>('/deeplink_generator/links', { link })
    .then(response => response.data);

export const updateLink = (id: number, link: Partial<Link>) =>
  http.dashboard
    .put<Link>(`/deeplink_generator/links/${id}`, { link })
    .then(response => response.data);

export const removeLink = (id: number) =>
  http.dashboard.delete<undefined>(`/deeplink_generator/links/${id}`).then(response => response.data);
